<template>
   <div>
    <div class="sidebar" id="sidebar" v-bind:class="{sidebar_closed:!isPanelOpen}">
        <div class="closing" v-on:click="sidebar()">
            <i class="large caret icon chevron-icon" v-bind:class="{left:!isPanelOpen,right:isPanelOpen}" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></i>
        </div>
        <span class="ui blue small ribbon label" style="position:absolute;top:40px;padding-left:15px;left:-14px">{{number_of_notes}}</span> 
        <div class="container"  v-bind:class="{hidden_list:!isPanelOpen || isPanelOpen && isPanelTrasitionEnd==false}">
            <TheNoteList v-bind:primary_item="primary_item" v-bind:concordances="concordances" v-bind:all_notes_view="false" @notesLoaded="notesLoaded"></TheNoteList>
        </div>
    </div>
</div>

</template>
<script>
    import TheNoteList from '../components/TheNoteList_v2.vue'

    export default {
        name: 'sidebar',
        props: ['primary_item', 'concordances'],
        components: {
            TheNoteList,
        },
        data() {
            return {
                isPanelOpen: false,
                isPanelTrasitionEnd: false,
                number_of_notes: 0,
            }
        },
        mounted() {
            var localThis = this;
            setTimeout(function() {
                $('#sidebar').on('transitionend webkitTransitionEnd oTransitionEnd', function() {
                    // your event handler
                    localThis.isPanelTrasitionEnd = true;
                });
            }, 200)
        },
        methods: {
            notesLoaded: function(val) {
                this.number_of_notes = val;
                if (val > 0 && !this.isPanelOpen) {
                    this.shakeBar();
                }
            },

            shakeBar: function() {
                setTimeout(function() {
                    $('#sidebar').transition('shake');
                }, 1500);
            },
            sidebar: function() {
                this.isPanelTrasitionEnd = false;
                if (this.isPanelOpen) {
                    this.isPanelOpen = false;
                    this.noteListDisplayed = false;
                }
                else {
                    this.isPanelOpen = true;
                    var myThis = this;
                    setTimeout(function() { myThis.noteListDisplayed = true }, 900);
                }
            },
        }
    }
</script>
<style scoped>
    .sidebar {
       /*  overflow-y: auto;*/
         overflow:visible;
         
      /* overflow: visible;*/
      
        background-color: #f8f8f9;
        position: fixed;
        right: 0;
        top: 0;
        height: 100vh;
        z-index: 59;
        padding: 0px 0px 0px 0px;
        width: 30%;
        border-left-style: solid;
        border-color: #A9A9A9;
        border-width: 1px;
        transition: width 1s;

    }

    .sidebar_closed {
        width: 15px!important;
        transition: width 1s;

    }

    .closing {
        height: 100%;
        width: 15px;
        cursor: pointer;
        position: absolute;
        margin: 0;
        background-color: rgb(215, 214, 214);
        text-align: center;
    }

    .content {
        padding: 80px 20px 0px 35px;
    }

    .chevron-icon {
        cursor: pointer;
        position: absolute;
        right: -10px;
        top: 50%;

    }

    .hidden_list {
        display: none;
        transition: display 1s;
    }
    
    .container{
       padding:55px 20px 10px 35px;
       height:100%;
       overflow-y:auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheSideBar_v2.vue